import _axios from '@/plugins/axios';
import { CCMError } from '../../../lib/Errors';

export default {
  async getCCMCarePlansByPatientId (patientId) {
    const response = await _axios.get(
      `/ccmcareplan/getbypatientid/${patientId}`,
    );
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error getting CCM care plans by patient ID');
  },
  async getCCMCarePlansByCCMRecordId (ccmRecordId) {
    const response = await _axios.get(
      `/ccmcareplan/getbyccmrecordid/${ccmRecordId}`,
    );
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error getting CCM care plans by CCM record ID');
  },
  async getCCMCarePlan (id) {
    const response = await _axios.get(`/ccmcareplan/${id}`);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error getting CCM care plan');
  },
  async updateCCMCarePlan (id, body) {
    const response = await _axios.put(`/ccmcareplan/${id}`, body);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error updating CCM care plan');
  },
  async deleteCCMCarePlan (id) {
    const response = await _axios.delete(`/ccmcareplan/${id}`);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error deleting CCM care plan');
  },
  async addCCMCarePlan (body) {
    const response = await _axios.post('/ccmcareplan/', body);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error adding CCM care plan');
  },
};
